import { render } from "./PoweringDailyLife.vue?vue&type=template&id=bd8bacc0&ts=true"
import script from "./PoweringDailyLife.vue?vue&type=script&lang=ts"
export * from "./PoweringDailyLife.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__